exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rn-tooltip .tooltip-inner{background:#241f2e;color:#fbfaf9;border-radius:8px;padding:9px 12px;font-size:12px;line-height:1.45;max-width:240px;text-align:left}.rn-tooltip .tooltip-inner b{display:block;font-weight:700;margin-bottom:2px;font-family:Poppins,sans-serif}.rn-tooltip .tooltip-arrow{border-color:#241f2e}.rn-tt-sub{color:#948da3;font-size:11px}.rn-tt-row{display:flex;justify-content:space-between;align-items:center;gap:10px;margin-top:5px}.rn-tt-chip{font-size:10px;font-weight:700;padding:2px 8px;border-radius:100px;border:1px solid}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a4f72a6","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=1!./src/components/frpm/components/variables-prioritarias/DomainNode.vue
// module id = 2165
// module chunks = 2